export enum ServiceTypes {
  BLOCKS = 'Blocks',
  USERS = 'Users',
  UPLOAD = 'Upload',
  PROJECTS = 'Projects',
  DATA_GRIDS = 'DataGrids',
  INGEST_JOBS = 'IngestJobs',
  GROUPS = 'Groups,',
  MICROSITE_TEMPLATE = 'MicrositeTemplate,',
  DOCUMENTS = 'Documents',
  PROJECT_TEMPLATES = 'ProjectTemplates',
  DOCUMENT_TEMPLATES = 'DocumentTemplates',
  JOBS = 'jobs',
  CCMS = 'CCMS',
  IMPERSONATE = 'Impersonate',
  GRANTS = 'grants',
  SLIDES = 'slides',
  AI = 'ai',
}

export const SERVICE_API_TAG_TYPES = [
  'Folders',
  'Assets',
  'Types',
  'Entities',
  'ProjectTemplates',
  'Presentations',
  ServiceTypes.GROUPS,
  ServiceTypes.UPLOAD,
  ServiceTypes.PROJECTS,
  ServiceTypes.DATA_GRIDS,
  ServiceTypes.INGEST_JOBS,
  ServiceTypes.DOCUMENT_TEMPLATES,
  ServiceTypes.JOBS,
  ServiceTypes.CCMS,
  ServiceTypes.DOCUMENTS,
  ServiceTypes.MICROSITE_TEMPLATE,
  ServiceTypes.BLOCKS,
  ServiceTypes.IMPERSONATE,
  ServiceTypes.GRANTS,
  ServiceTypes.SLIDES,
  ServiceTypes.AI,
] as const;
